/**
 * Whether an email belongs to Finlay staff. Staff roles alone do not say it:
 * client users can hold them too. Mirrors finlay-api
 * `OutreachSenderResolver.IsFinlayStaff`.
 */
export const isFinlayStaffEmail = (email: string | null | undefined) =>
  email?.toLowerCase().endsWith('@finlay.ai') === true;
